import '@/core/http';
import JSONbig from 'json-bigint';
import '@/components/Dialog';
import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/style/index.scss';
import '@/core/mixins/global.js';
import App from './App';
import router from './router';
import store from './store';
import TreeSelect from '@/components/TreeSelect';
import RichEditor from '@/components/RichEditor';
// import InputNumberRange from '@/components/InputNumberRange';
import DateRange from '@/components/DateRange';
import FilterBox from '@/components/FilterBox';
import TableProgressColumn from '@/components/TableProgressColumn';
import UserSelect from '@/components/UserSelect';
import DeptSelect from '@/components/DeptSelect';
import VCharts from 'v-charts';
import VXETable from 'vxe-table';
import 'vxe-table/lib/style.css';
import '@/assets/online-icon/iconfont.css';
import nodeWrap from '@/views/workflow/components/ProcessDingflowDesigner/nodeWrap'
import Vue2OrgTree from 'vue-tree-color'
// -----------WPS
// import * as WPS from './static/jwps.es6.1.3'
import * as WPS from './static/web-office-sdk-solution-v2.0.4.umd.js'
import comFun from './comfun/index'

// 拖拽组件
import dragSort from '@/components/vuedraggable/src/vuedraggable'
// 自定义组件
import myHtml from '@/components/myHtml';
import myTable from '@/components/myTable';
import myOperate from '@/components/myOperate';
import myImages from '@/components/myImages';
import myUpLoad from '@/components/myUpLoad';
import myUpdateUpLoad from '@/components/myUpdateUpLoad';
import myUploadTable from '@/components/myUploadTable';
import myFileCount from '@/components/myFileCount';
import myDragSort from '@/components/dragSort.vue';
import dialogDragSort from '@/components/dialogDragSort.vue';
import inputNumberRange from '@/components/inputNumberRange'; // 阿伟的数字区间组件
import myExportExcel from '@/components/myExportExcel';
import mySelectList from '@/components/mySelectList';
import myCustomFields from '@/components/myCustomFields.vue';
import myOrderDetails from '@/components/myOrderDetails.vue';
import myOrderAdd from '@/components/myOrderAdd.vue';

// import VueGanttChart from 'vue-gantt-chart'
// Vue.use(VueGanttChart)
import Prints from './utils/easyPrint'
import Print from 'vue-print-nb'
import directive from '@/utils/directive';

// 分页组件
import Pagination from '@/components/Pagination';
// 富文本组件
import Editor from '@/components/myTinymce/index'
// 打印组件
import printView from '@/components/printView.vue';
// 打印组件另一版
import printViewFun from '@/components/printViewFun.vue';
// 打印组件按钮版
import printViewBtn from '@/components/printViewBtn.vue';
// 日期格式化
import moment from 'moment';
// 粒子特效
import VueParticles from 'vue-particles'
// 导出excel
import JsonExcel from 'vue-json-excel'
// 图片预览
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
// Vue.use(LuckyExcel);

// 打印模板
import { hiPrintPlugin } from 'vue-plugin-hiprint';

Vue.prototype.console = console;
Vue.prototype.wps = WPS;
Vue.use(comFun);
Vue.use(Prints)
Vue.use(Print)
Vue.use(directive)

// 在线编辑excel
// import LuckyExcel from 'luckyexcel'
Vue.prototype.$moment = moment;
Vue.use(VueParticles)
Vue.component('downloadExcel', JsonExcel)
Vue.use(Viewer)
Vue.use(hiPrintPlugin, '$pluginName')
hiPrintPlugin.disAutoConnect(); // 取消自动连接直接打印客户端

// 甘特图
// import echarts from "echarts";
// Vue.prototype.$echarts = echarts

Vue.component('printViewFun', printViewFun)
Vue.component('printViewBtn', printViewBtn)
Vue.component('printView', printView)
Vue.component('Editor', Editor)
Vue.component('Pagination', Pagination)
Vue.component('myOperate', myOperate)
Vue.component('myImages', myImages)
Vue.component('myHtml', myHtml)
Vue.component('myTable', myTable)
Vue.component('myUpLoad', myUpLoad)
Vue.component('myUpdateUpLoad', myUpdateUpLoad)
Vue.component('myUploadTable', myUploadTable)
Vue.component('myFileCount', myFileCount)
Vue.component('myDragSort', myDragSort)
Vue.component('dragSort', dragSort)
Vue.component('dialogDragSort', dialogDragSort)
Vue.component('nodeWrap', nodeWrap)
Vue.component('inputNumberRange', inputNumberRange)
Vue.component('myExportExcel', myExportExcel)
Vue.component('mySelectList', mySelectList)
Vue.component('myCustomFields', myCustomFields)
Vue.component('myOrderDetails', myOrderDetails)
Vue.component('myOrderAdd', myOrderAdd)

Vue.use(VXETable);
window.JSON = new JSONbig({ storeAsString: true });
Vue.component('tree-select', TreeSelect);
Vue.component('rich-editor', RichEditor);
// Vue.component('input-number-range', InputNumberRange);
Vue.component('date-range', DateRange);
Vue.component('filter-box', FilterBox);
Vue.component('table-progress-column', TableProgressColumn);
Vue.component('user-select', UserSelect);
Vue.component('dept-select', DeptSelect);
Vue.use(ElementUI);
Vue.use(VCharts);
Vue.use(Vue2OrgTree);

Vue.config.productionTip = false;
Vue.config.silent = true;

import {
  requestRepeat,
  convertDate
} from '@/utils/myUtils';
Vue.prototype.$requestRepeat = requestRepeat;
Vue.prototype.$convertDate = convertDate;

// import i18n from '@/lang'
var screenHeight = document.documentElement.clientHeight || document.body.clientHeight
/* eslint-disable no-new */
const vm = new Vue({
  router,
  store,
  // i18n,
  render: h => h(App),
  data() {
    return {
      route_path: '', // 自定义全局变量
      route_all_path: [], // 所有路由
      home_radio: '', // 页面布局
      screenHeight: screenHeight,
      tableHeight: screenHeight - 270,
      menuId: null,
      // 默认仓库
      warehouseId: null,
      warehouseName: null,
      // 自定义字段
      sysEntityExt_1: [], // 产品
      sysEntityExt_6: [], // 客户
      sysEntityExt_8: [], // 工序
      sysEntityExt_11: [], // 供应商
      sysEntityExt_131: [], // 生产单
      sysEntityExt_132: [], // 设计中心
      sysEntityExt_136: [], // BOM主表
      sysEntityExt_137: [], // BOM物料
      sysEntityExt_138: [], // BOM工序
      sysEntityExt_601: [], // 客户跟进记录
      sysEntityExt_101: [], // 销售订单主表
      sysEntityExt_102: [], // 销售订单子表
      sysEntityExt_103: [], // 销售出库订单主表
      sysEntityExt_104: [], // 销售出库订单子表
      sysEntityExt_105: [], // 销售对账
      sysEntityExt_121: [], // 采购订单主表
      sysEntityExt_122: [], // 采购订单子表
      sysEntityExt_123: [], // 采购入库订单主表
      sysEntityExt_124: [], // 采购入库订单子表
      sysEntityExt_125: [], // 采购对账
      sysEntityExt_151: [], // 样品单主表
      sysEntityExt_152: [], // 样品单子主表
      sysEntityExt_141: [], // 报价单主表
      sysEntityExt_142: [], // 报价单子主表
      sysEntityExt_153: [], // 日报
      sysEntityExt_183: [], // 项目管理
      sysEntityExt_185: [], // 收支明细
      color: '#1476c3', // 背景颜色
      accuracy: 4, // 价格精度
      numberAccuracy: 2, // 数量精度
      bomIsShowPrice: 1, // 1价格啥的都显示，2不显示价格
      repeatDataTime: new Date().getTime(), // 防止接口重复提交
      repeatDataTimeData: {}, // 防止接口重复提交
      messageCount: 0, // 未读消息数量
      mainTitleList: {}, //全局列表配置缓存

      // 产品下拉框信息
      productTitleList: [
        {
          id: 1,
          name: '产品编号',
          value: 'baseMaterialNumber',
          dataType: 'text',
          width: 90
        },
        {
          id: 2,
          name: '产品名称',
          value: 'baseMaterialName',
          dataType: 'text',
          width: 90
        },
        {
          id: 3,
          name: '规格型号',
          value: 'specifications',
          dataType: 'textList',
          width: 200
        },
        {
          id: 4,
          name: '产品类别',
          value: 'baseMaterialTypeName',
          dataType: 'text',
          width: 90
        },
        {
          id: 5,
          name: '单位',
          value: 'baseMaterialUnitName',
          dataType: 'text',
          width: 90
        },
        {
          id: 4,
          name: '客户料号',
          value: 'customerMaterialNumber',
          dataType: 'text',
          width: 90
        }
      ]
    }
  }
});
vm.$mount('#app');
Vue.prototype.$vm = vm;
export default vm
